import { useState } from "react";
import { useNavigate } from "react-router-dom";
import dumy_dog from "../../../assets/images/dumy_dog.png";
import PetPurchaseDetailModal from "../user-lab-result/PetPurchaseDetailModal";

type PropsType = {
  avatar?: any;
  name?: string;
  gender?: string;
  breed?: string;
  _id?: string;
};
const PetRow = ({ avatar, name, gender, breed, _id }: PropsType) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <div className="tw-flex tw-items-center tw-pb-3">
        <div className="tw-w-[5%] tw-mr-1">
          <img
            src={avatar ? avatar : dumy_dog}
            className="tw-w-[40px] tw-h-[40px] tw-object-cover tw-rounded-full"
            alt="pet"
          />
        </div>
        {/* User data */}
        <div className="tw-w-[95%] tw-flex tw-items-center tw-justify-between">
          <div className="tw-flex-1">
            <p
              onClick={() => setShowModal(true)}
              className="tw-text-xl tw-cursor-pointer tw-capitalize tw-text-[rgb(0,0,0)] tw-font-normal"
            >
              {name ? name : "None"}
            </p>
          </div>
          <div className="tw-flex-1">
            <p className="tw-text-xl tw-text-[#000000] tw-font-normal">{gender ? gender : "None"}</p>
          </div>
          <div className="tw-flex-[1.5_1.5_0%]">
            <p className="tw-text-xl tw-capitalize tw-text-[#000000] tw-font-normal">{breed ? breed : "None"}</p>
          </div>
          <div className="tw-flex-1 tw-flex tw-items-center tw-justify-end">
            <button
              className="tw-flex tw-items-center tw-justify-center tw-text-lg tw-text-[#FFFFFF] tw-font-bold tw-bg-[#FF7B6D] tw-py-2 tw-px-8 tw-rounded-md"
              onClick={() => {
                navigate(`/user/pets/pet-details/${_id}`);
              }}
            >
              Pet Details
            </button>
          </div>
        </div>
      </div>
      <hr className="tw-w-[70%] tw-border-[1px] tw-border-solid tw-border-black tw-relative tw-left-[50px]" />
      {/* Modal Component */}
      {showModal && <PetPurchaseDetailModal open={showModal} handleClose={() => setShowModal(false)} petId={_id} />}
    </>
  );
};
export default PetRow;
